export enum LimitedTimeOfferExpirationTypeEnum {
  DATE_TIME_PICKER = 'DATE_TIME_PICKER',
  DELAY = 'DELAY',
}
